export const transactionDummyChartData = {
	chartId: 'transaction',
	labels: [],
	datasets: [
		{
			label: 'Transaction',
			borderColor: 'rgba(88, 192, 202, 0.6)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#FFFFFF',
			backgroundColor: 'rgba(88, 192, 202, 0.6)',
			data: [],
		}, {
			label: 'Order',
			borderColor: 'rgba(88, 192, 202, 0.3)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#FFFFFF',
			backgroundColor: 'rgba(88, 192, 202, 0.3)',
			data: [],
		},
	],
};

export const commissionDummyChartData = {
	chartId: 'commission',
	labels: [],
	datasets: [
		{
			label: 'Commission',
			borderColor: 'rgba(88, 192, 202, 0.6)',
			pointBackgroundColor: '#FFFFFF',
			borderWidth: 1,
			pointBorderColor: '#FFFFFF',
			backgroundColor: 'rgba(242, 137, 0, 0.6)',
			data: [],
		},
	],
};

export const revenueDummyChartData = {
	chartId: 'revenue',
	labels: ['', '', '', '', '', '', ''],
	datasets: [
		{
			backgroundColor: '#75cfd8',
			data: [],
		},
	],
};

export const customerDummyChartData = {
	chartId: 'customer',
	labels: ['', '', '', '', '', '', ''],
	datasets: [
		{
			backgroundColor: ['blue'],
			data: [],
		},
	],
};
